import { SET_SHG_TRAINING_VIEW } from "../type";


const initialState = {
    shgTrainingView: 'calendar',

}
export const shgTrainingReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_SHG_TRAINING_VIEW:
            return {
                ...state,
                shgTrainingView: action.payload.viewName,
            };
        default:
            return state

    }
}